import React, { useState, useCallback, useEffect } from 'react'
import { useField } from 'formik'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

export default ({ label, instantValidate, ...props }) => {
    useStyles(classes)
    const [field, meta, helpers] = useField(props)
    const [filled, setFilled] = useState(!!field?.value)
    const [focused, setFocused] = useState(false)

    useEffect(() => {
        setFilled(!!field?.value || focused || props.placeholder)

        if(field.value?.length >= 6 && field.value?.indexOf('-') < 0){
            helpers.setValue(field.value.slice(0, 5) + '-' + field.value.slice(5))
        }
    }, [field.value, focused, props.placeholder])

    const focusHandle = useCallback(e => {
        setFocused(true)
    }, [])

    const blurHandle = useCallback(e => {
        field.onBlur(e)
        setFocused(false)
    }, [])

    useEffect(() => {
        if (instantValidate) {
            helpers.setTouched(true, true)
        }
    }, [instantValidate])

    return <div className={`${classes.Container} ${meta.touched && meta.error ? classes.Errored: ''}`}>
        <label className={`${filled? classes.Focused: ''}`}>
            {label}
        </label>
        <div className={`${classes.InputWrapper} ${focused? classes.Focused: ''}`}>
            <input className={classes.Input} {...field} {...props}  autoComplete='off' onFocus={focusHandle} onBlur={blurHandle}/>
        </div>
        {meta.touched && meta.error && <div className={classes.Error}>{meta.error}</div>}
    </div>
}